import { isLicensed } from "./selectors";
import { activateAsset } from "../bridge/actions";
import { searchBookContent } from "../search/actions";
import { launchLicensedBook } from "../book/actions";

export function activateAssetIfNeeded(isbn) {
  return function(dispatch, getState) {
    if (isLicensed(getState(), isbn)) {
      return Promise.resolve();
    }
    return dispatch(activateAsset(isbn));
  };
}

/**
 * We probably won't ever use this again now that we support
 * searching books without activating - see redux/search/actions.
 * Eventually want to remove this once we confirm things work.
 */
export function searchBookWithActivationIfNeeded(isbn, query) {
  return function(dispatch) {
    return dispatch(activateAssetIfNeeded(isbn)).then(() =>
      dispatch(searchBookContent(isbn, query))
    );
  };
}

export function launchBookWithActivationIfNeeded(isbn, options) {
  return function(dispatch) {
    return dispatch(activateAssetIfNeeded(isbn)).then(() =>
      dispatch(launchLicensedBook(isbn, options))
    );
  };
}
